import React, { useState } from "react";
import "./flight-sidebar.scss";
import { FaWindowClose } from "react-icons/fa";
import AirlinesFilter from "./AirlinesFilter";
import TimesFilter from "./TimesFilter";
import SingleSelectFilter from "./SingleSelectFilter";
import { CloseOutlined } from '@ant-design/icons';
import {Button} from 'antd';

const FlightSidebar = ({ isLoading, onToggle, flightSearchParams, flightSearchResult, fetchFlights, filterTags, setFilterTags, fetchFlightsWithFilter}) => {
  const [isHidden, setIsHidden] = useState(false);

  const airlinesFilterOnChange = async (selected, option) => {
    let filterTag = {
      key: `airline:${option.iata}`,
      label: `${option.name}`,
      value: option.iata
    };
    
    const filterTagsOnChange = (prev) => {
      if (!!selected) {
        return [...prev, filterTag];
      } else {
        return prev.filter(tag => tag.key !== filterTag.key);
      }
    }

    const newFilterTags = filterTagsOnChange(filterTags);
    setFilterTags(newFilterTags);

    await fetchFlightsWithFilter(newFilterTags);
  }

  const timesFilterOnChange = async (key, value) => {
    let filterTag;
    if (key === 'depart') {
        filterTag = {
          key: key,
          label: `Departure: ${fmtTime(value[0])} - ${fmtTime(value[1])}`,
          value: {start: value[0], end: value[1]}
        }
    } else if (key === 'arrive') {
      filterTag = {
        key: key,
        label: `Arrival: ${fmtTime(value[0])} - ${fmtTime(value[1])}`,
        value: {start: value[0], end: value[1]}
      }
    } else {
      return;
    }
    
    let newFilterTags;
    const existingIndex = filterTags.findIndex(tag => tag.key === filterTag.key);
    if (existingIndex !== -1) {
      const filtered = filterTags.filter(tag => tag.key !== filterTag.key);
      newFilterTags = [...filtered, filterTag];
    } else {
      newFilterTags = [...filterTags, filterTag];
    }
    setFilterTags(newFilterTags);

    await fetchFlightsWithFilter(newFilterTags);
  }

  function fmtTime(h) {
    const hh = Math.floor(h);
    const mm = Math.round((h - hh) * 60);
  
    const hhStr = String(hh).padStart(2, '0');
    const mmStr = String(mm).padStart(2, '0');
  
    return `${hhStr}:${mmStr}`;
  }

  const stopsFilterOnChange = async (option) => {
    let newFilterTags;
    if (!!option) {
      let filterTag = {
        key: 'stops',
        label: option.name,
        value: option.type
      };
      
      newFilterTags = filterTags.filter(tag => tag.key !== 'stops');

      newFilterTags = [...newFilterTags, filterTag];
    } else {
      newFilterTags = filterTags.filter(tag => tag.key !== 'stops');
    }
    setFilterTags(newFilterTags);

    await fetchFlightsWithFilter(newFilterTags);
  }

  async function removeFilterTag(filterTag) {
    const newFilterTags = filterTags.filter(tag => tag.key !== filterTag.key);
    setFilterTags(newFilterTags);

    await fetchFlightsWithFilter(newFilterTags);
  }

  async function clearAllFilterTags() {
    const newFilterTags = [];
    setFilterTags([]);

    await fetchFlightsWithFilter(newFilterTags);
  }

  if (isLoading) {
    return;
  }

  return (
    <div className={`flight-sidebar ${isHidden ? "hide-sidebar" : ""}`}>
      <button id="toggle_hide" onClick={onToggle}>
        <FaWindowClose />
      </button>

      {/* Map box */}
      {/* <div className="map-box" style={{ height: 110 }}>
        <a to="" className="custom-btn">
          Show on Map
        </a>
      </div> */}

      {/* Previous Filters */}
      {filterTags.length > 0 && (
        <div className="wrap-box">
          <div className="row" style={{paddingRight: "16px"}}>
            <h6 style={{ flex: "0 0 70%" }}>Filters</h6>
            <button
              type="button"
              className="d-block mb-2 text-primary btn btn-link p-0"
              style={{ marginLeft: 'auto', fontSize: "14px", flex: "0 0 30%", textAlign: 'right' }}
              onClick={clearAllFilterTags}
            >
              Clear All
            </button>
          </div>
          <div className="filter-tags-container">
            {filterTags.map((tag) => (
              <div className="filter-tag">
                <div className="filter-tag-label">{tag.label}</div>
                <Button
                  type="text"
                  className="filter-tag-remove"
                  icon={<CloseOutlined />}
                  onClick={() => removeFilterTag(tag)}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {!!flightSearchResult.filterDefinitions &&
        flightSearchResult.filterDefinitions.length > 0 &&
        flightSearchResult.filterDefinitions.map((filterDefinition) => {
          if (filterDefinition.type === "airlines") {
            return (
              <AirlinesFilter
                key={filterDefinition.type}
                filterTags={filterTags}
                filterDefinition={filterDefinition}
                onChange={airlinesFilterOnChange}
              />
            );
          } else if (filterDefinition.type === "times") {
            return (
              <TimesFilter
                key={filterDefinition.type}
                filterTags={filterTags}
                filterDefinition={filterDefinition}
                onChange={timesFilterOnChange}
              />
            );
          } else if (filterDefinition.type === "stops") {
            return (
              <SingleSelectFilter
                key={filterDefinition.type}
                filterKey={filterDefinition.type}
                filterTags={filterTags}
                filterDefinition={filterDefinition}
                allowDeselect={true}
                onChange={(value) => stopsFilterOnChange(value)}
              />
            );
          } else if (
            filterDefinition.type === "cabin" &&
            flightSearchParams.journeyNo === 1
          ) {
            return (
              <SingleSelectFilter
                key={filterDefinition.type}
                filterKey={filterDefinition.type}
                filterTags={filterTags}
                filterDefinition={filterDefinition}
                allowDeselect={true}
                onChange={(value) => console.log(value)}
              />
            );
          }
        })}
    </div>
  );
};

export default FlightSidebar;
